const Public = {
  capitalizeFirstLetter: string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  precisionRound: (number, precision) => {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  },
};

export default Public;



// WEBPACK FOOTER //
// ./src/services/utility.js